import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 32px 24px 64px;
  color: ${Colors.commons.black};
`;

export const Title = styled.h1`
  font-size: 28px;
  margin: 0 0 24px;
  color: ${Colors.commons.black};
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  margin: 24px 0 8px;
  color: ${Colors.commons.black};
`;

export const Paragraph = styled.p`
  font-size: 15px;
  line-height: 1.6;
  margin: 0 0 12px;
  color: ${Colors.commons.darkGray};
`;

export const Link = styled.a`
  color: ${Colors.primary[100]};
  text-decoration: underline;
`;
